import { createQueryKeys } from '@lukemorales/query-key-factory';

import { get } from '@/api/api';
import { buildQueryParams } from '@/hooks/api/helpers';
import type { FanguardApiContractsClientEventDetailModel } from 'src/api/generated';
import { PagedResponse } from 'src/types/GlobalTypes';

export const EVENTS_URI = 'events';

export const eventsQueries = createQueryKeys(EVENTS_URI, {
  all: null,
  list: (venueId?: string, page?: number, pageSize?: number, viewMode?: 'calendar' | 'list') => ({
    queryKey: [venueId, page, pageSize, viewMode],
    queryFn: async () => {
      // remove extra params if in calendar view mode
      if (viewMode === 'calendar') {
        page = undefined;
        pageSize = undefined;
        viewMode = undefined;
      }
      const response = await get<PagedResponse<FanguardApiContractsClientEventDetailModel>>({
        uri: `${EVENTS_URI}?${buildQueryParams({ venueId, page, pageSize, viewMode })}`,
      });
      return response.data;
    },
  }),
  detail: (eventId: string) => ({
    queryKey: [eventId],
    queryFn: async () => {
      const response = await get<FanguardApiContractsClientEventDetailModel>({
        uri: `${EVENTS_URI}/${eventId}`,
      });
      return response.data;
    },
  }),
});
